import { render, staticRenderFns } from "./StudioCommunityChatRoomItem.vue?vue&type=template&id=d9f014be&scoped=true&"
import script from "./StudioCommunityChatRoomItem.vue?vue&type=script&lang=js&"
export * from "./StudioCommunityChatRoomItem.vue?vue&type=script&lang=js&"
import style0 from "./StudioCommunityChatRoomItem.vue?vue&type=style&index=0&id=d9f014be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f014be",
  null
  
)

export default component.exports